import Vue from 'vue';

const state = {
  
  tipos: [],
  tutorias: [],
  sedeActual: null,
  temas: null,
  horariosDisponibles: null,
  opcionesDisponibles: null,
  ultima_actualizacion: null,
  ultima_actualizacion_horarios: null,
  ultima_actualizacion_opciones: null,
  debe_aceptar_terminos: false,
  terminos_y_condiciones: null,
  registro_academico_actual: [],
  finalizar_nivel_resultado: null,
  solicitar_avance_resultado: null
};

const actions = {
  fetchTutorias:({commit},payload) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutorias',payload).then(
        response =>{
          commit('setTutorias',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  fetchTipos:({commit}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('ver_tipos').then(
        response =>{
          commit('setTipos',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  fetchSedeActual:({commit}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('sede').then(
        response =>{
          commit('setSedeActual',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  fetchHorarios:({commit},temaId) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('horarios',{tema_id:temaId}).then(
        response =>{
          commit('setHorariosDisponibles',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setHorariosDisponibles',null);
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  fetchOpciones:({commit},temaId) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('opciones',{tema_id:temaId}).then(
        response =>{
          commit('setOpcionesDisponibles',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setOpcionesDisponibles',null);
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  fetchDisponibilidad:({commit}, showError = true) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/ver-disponibilidad').then(
        response =>{

          commit('setTemas',response.data.temas);
          commit('setHorariosDisponibles',response.data.horarios);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setTemas',null);
        commit('setHorariosDisponibles',null);
        if (showError) {
          commit('setError', error, { root: true });
        }
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  agendar:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/agendar',data).then(
        response =>{
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setErrorModal', error, { root: true});
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  cancelar:({commit,dispatch},tutoriaId) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/cancelar',{
        tutoria_id:tutoriaId,
        }).then(
        response =>{
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
        dispatch('fetchTutorias')
      })
    });
  },
  aceptar:({commit,dispatch},tutoriaId) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/aceptar',{
          tutoria_id:tutoriaId,
        }).then(
        response =>{
          dispatch('fetchTutorias')
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  verificarAceptacionTerminos:({commit,dispatch}) => {
    commit('startProcessing', null, { root: true });
    
      Vue.http.post('verificar_terminos').then(
        response =>{
          if(response.data.codigo){
            if(response.data.codigo=='requerido'){
              commit('setDebeAceptarTerminos',true);
              commit('setTerminosYCondiciones',response.data.texto);
            }else if(response.data.codigo=='aceptado'){
              commit('setDebeAceptarTerminos',false);
              commit('setTerminosYCondiciones',response.data.texto);
            }else if(response.data.codigo=='desactivado'){
              commit('setDebeAceptarTerminos',false);
            }
          }else{
            commit('setDebeAceptarTerminos',false);
          }
    
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
    
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    
  },

  aceptarTerminos:({commit,dispatch}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('aceptar_terminos').then(
        response =>{
          if(response.data.codigo){
            if(response.data.codigo=='ok'){
              commit('setDebeAceptarTerminos',false);
              if(response.data.mensaje){
                commit('setWarning', response.data.mensaje, { root: true });  
              }
            }
          }
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
        reject(error)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  fetchRegistroAcademicoActual:({commit}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('registro_academico_actual').then(
        response =>{
          commit('setRegistroAcademicoActual',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  
  fetchSolicitarAvance:({commit}, data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('solicitar-avance', data).then(
        response =>{
          commit('setFinalizarNivel',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  fetchCursoFinalizado:({commit}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.get('curso_finalizado').then(
        response =>{
          commit('setCursoFinalizado',response.data.dato);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  avanzarNivel:({commit}, data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('avanzar_nivel', data).then(
        response =>{
          commit('setSolicitarAvance',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },

  fetchEncuestas:({commit}) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.get('tutoria/encuestas').then(
        response =>{
          commit('setEncuesta',response.data);
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
  saveEncuesta:({commit}, data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('tutoria/guardar_encuesta', data).then(
        response =>{
          resolve(response.data)
        }
      ).catch(error=>{
        commit('setError', error, { root: true });
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  }
  
  
};

const getters = {
  formattedClases: state => {
    let tutorias = [];
      if(state.tutorias && state.tutorias.length) {
        state.tutorias.map(agendamiento => {
          let puedecancelar = false;
          let infoclase = null
          let texto_estado = agendamiento.estado

          if(agendamiento.estado=='confirmado'){
            texto_estado = 'salon asignado'
            if(agendamiento.salon.numero){
              infoclase = agendamiento.salon.numero+' '+agendamiento.salon.nombre
            }else{
              infoclase = agendamiento.salon.nombre
            }
            
          }else if(agendamiento.estado=='solicitado'){
            puedecancelar = true;              
          }
          
          let texto_tipo_clase = 'Sin definir'

          tutorias.push({
              id: agendamiento.id,
              tipo_clase: texto_tipo_clase,
              tema: agendamiento.tema?agendamiento.tema.nombre:'Sin definir',
              fecha: agendamiento.fecha,
              hora: agendamiento.hora,
              estado: texto_estado.toUpperCase(),
              puedecancelar:puedecancelar,
              infoclase:infoclase
          })   
        });
      }
      return tutorias;
  },
  clasesPendientes: state => {  
     let pendientes =  state.tutorias.filter(agendamiento =>{
        return agendamiento.estado != 'cancelado'
     })
     return pendientes 
  },
  getTipo: (state) => (codigo) => {
      return  state.tipos.find((element)=>{
        return element.id == codigo
      })
  },
};

const mutations = {
  setDebeAceptarTerminos: (state, data) => {
    state.debe_aceptar_terminos = data;
  },
  setTerminosYCondiciones: (state, data) => {
    state.terminos_y_condiciones = data;
  },
  setTipos: (state, data) => {
    state.tipos = data;
  },
  setTutorias: (state, data) => {
    state.tutorias = data;
    state.ultima_actualizacion = new Date()
  },
  setSedeActual: (state, data) => {
    state.sedeActual = data;
  },
  setTemas: (state, tema) => {
    state.temas = tema;
  },
  setHorariosDisponibles: (state, horarios) => {
    state.horariosDisponibles = horarios;
    state.ultima_actualizacion_horarios = new Date()
  },
  setOpcionesDisponibles: (state, horarios) => {
    state.opcionesDisponibles = horarios;
    state.ultima_actualizacion_opciones = new Date()
  },
  setRegistroAcademicoActual: (state, data) => {
    state.registro_academico_actual = data;
  },
  setFinalizarNivel: (state, data) => {
    state.finalizar_nivel_resultado = data;
  },
  setCursoFinalizado:(state, data) => {
    state.curso_finalizado = data;
  },
  setSolicitarAvance: (state, data) => {
    state.avance_nivel_resultado = data;
  },
  setEncuesta: (state, data) => {
    state.encuestas = data;
  },
  
  clear: (state) => {
    state.tutorias = [];
    state.sedeActual = null;
    state.temasDisponibles = [];
    state.horariosDisponibles = null;
    state.opcionesDisponibles = null;
    state.registro_academico_actual = [];
    state.finalizar_nivel_resultado = null;
    state.curso_finalizado = null;
    state.avance_nivel_resultado = null;
    state.encuestas = null;
    
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
